import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Fatura } from '../model/fatura';
import { ResultadoEmailEnviado } from '../model/resultado-email-enviado';

@Injectable({
  providedIn: 'root'
})
export class FaturamentoService {
  // URL absoluta (não relativa ao <base href>, que varia por action MVC) - garante que a URL
  // real da chamada bata com o protectedResourceMap do MsalInterceptor (app.module.ts).
  readonly urlMultipla = window.location.origin + '/';
  readonly spHostParam = 'https://multiplati1.sharepoint.com/administrativo/mc/Contratos';

  constructor(private http: HttpClient) { }

  buscaFaturas(competencia: string, cliente: string|null, vencimento: Date|null, liberada: boolean|null = null, faturaId: number|null = null): Observable<Fatura[]>{
    let params : any = {
      'SPHostUrl': this.spHostParam
    };

    if (competencia) params['competencia'] = competencia;

    if (cliente) params['cliente'] = cliente;

    if (vencimento) params['vencimento'] = this.formatData(vencimento);

    if (liberada !== null && liberada !== undefined) params['liberada'] = liberada;

    if (faturaId !== null && faturaId !== undefined) params['faturaId'] = faturaId;

    return this.http.get<Fatura[]>(this.urlMultipla + 'Faturamento/BuscarFaturasJson', {
      params: params
    });
  }

  enviarEmails(faturas: Fatura[], liberar: boolean): Observable<ResultadoEmailEnviado> {
    let params: any = {
      'SPHostUrl': this.spHostParam,
      'faturaIds': faturas.map(f => f.FaturaId).join(','),
      'liberarFaturas': liberar
    };

    return this.http.get<ResultadoEmailEnviado>(this.urlMultipla + 'Faturamento/EnviarEmailJson', {
      params: params
    });
  }

  gerarFaturasRecorrentes(competenciafatura: string, inicioPeriodo: Date, fimPeriodo: Date): Observable<any> {
    let params: any = {
      'SPHostUrl': this.spHostParam,
      'competenciafatura': competenciafatura,
      'inicioPeriodo': this.formatData( inicioPeriodo),
      'fimPeriodo': this.formatData(fimPeriodo)
    };

    return this.http.post<any>(this.urlMultipla + 'Faturamento/GerarFaturasRecorrenteJson',params);
  }

  gerarFaturasMarcos(competenciafatura: string, inicioPeriodo: Date, fimPeriodo: Date): Observable<any> {
    let params: any = {
      'SPHostUrl': this.spHostParam,
      'competenciafatura': competenciafatura,
      'inicioPeriodo': this.formatData(inicioPeriodo),
      'fimPeriodo': this.formatData(fimPeriodo)
    };

    return this.http.post<any>(this.urlMultipla + 'Faturamento/GerarFaturasMarcoJson', params);
  }

  formatData(data: Date) { return data.getDate() + "/" + (data.getMonth() + 1) + "/" + data.getFullYear(); }
}
